import React, { FormEvent, useState } from 'react';
import { Drawer } from 'shared/ui/Drawer/DrawerPromo';
import { PromoUploadExcel } from 'features/fileUpload/ui/PromoUploadExcel';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useUploadShopDotsExcelMutation } from 'features/fileUpload/api/uploadFileApi';
import { useDispatch } from 'react-redux';

type UploadShopDotsCardPropsType = {
  id: string;
};
export const UploadShopDotsCard = ({ id }: UploadShopDotsCardPropsType) => {
  const dispatch = useDispatch();
  const [selectedFileShopDots, setSelectedFileShopDots] = useState<File | null>(null);

  const [uploadFileShopDots] = useUploadShopDotsExcelMutation();

  const onSubmitUploadShopDotsExcel = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const params = {
      id,
      file: selectedFileShopDots,
    };
    uploadFileShopDots(params)
      .then((res: any) => {
        if (res.data) {
          setSelectedFileShopDots(null);
          dispatch(setDrawerOpen(false));
          window.open('/downloads/shop-dots', '_blank');
        }
      })
      .catch(() => window.open('/downloads/shop-dots', '_blank'));
  };

  return (
    <Drawer title="Загрузить новые торговые точки">
      <PromoUploadExcel
        onSubmit={onSubmitUploadShopDotsExcel}
        setFile={setSelectedFileShopDots}
        file={selectedFileShopDots}
      />
    </Drawer>
  );
};
